export const disabledEscKeyHandler = (event: KeyboardEvent) => {
  const key = event?.key?.toLowerCase();
  if (key === 'escape' || key === 'esc') {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
};
